import * as axios from 'axios';

const { VUE_APP_API_URL } = process.env || {};
export const getStoreTypes = (token) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/storeTypes`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});

export const getStoreType = (token, storeTypeId) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/storeTypes/${storeTypeId}`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const createStoreType = (token, body) => axios.post(`${VUE_APP_API_URL}/api/v1/admin/storeTypes`, body, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const updateStoreType = (token, id, body) => axios.put(`${VUE_APP_API_URL}/api/v1/admin/storeTypes/${id}`, body, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const deleteStoreType = (token, id) => axios.delete(`${VUE_APP_API_URL}/api/v1/admin/storeTypes/${id}`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
